import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = (theme) => ({
  root: {
    marginBottom: theme.spacing(4),
  },
  title: {},
  subtitle: {
    marginTop: theme.spacing(1),
  },
});

const OnboardingHeader = ({
  className,
  classes,
  title,
  subTitle,
  centered,
  variant,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        className={classes.title}
        variant={!variant ? 'h2' : variant}
        weight={'medium'}
        color={'primary'}
        align={centered ? 'center' : 'inherit'}
      >
        {title}
      </Typography>
      {subTitle && (
        <Typography
          className={classes.subtitle}
          variant={'h5'}
          color={'accentBlue19'}
          align={centered ? 'center' : 'inherit'}
        >
          {subTitle}
        </Typography>)
      }
    </Box>
  );
};

OnboardingHeader.defaultProps = {
  className: '',
  subTitle: '',
  centered: false,
  variant: null,
};

OnboardingHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  centered: PropTypes.bool,
  variant: PropTypes.string,
};

export default withStyles(styles)(OnboardingHeader);
